import _classCallCheck from "/home/circleci/project/mhub-leads-v2-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _toConsumableArray from "/home/circleci/project/mhub-leads-v2-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

/*! name: @uvarov.frontend/vanilla-calendar | url: https://github.com/uvarov-frontend/vanilla-calendar */
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return a;
};

var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  return value;
};

var generateDate = function generateDate(date) {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  month = month < 10 ? "0".concat(month) : month;
  day = day < 10 ? "0".concat(day) : day;
  return "".concat(year, "-").concat(month, "-").concat(day);
};

var parserDates = function parserDates(dates) {
  var newDates = [];
  dates.forEach(function (date) {
    if (date.match(/^(\d{4}-\d{2}-\d{2})$/g)) {
      newDates.push(date);
    } else {
      date.replace(/(\d{4}-\d{2}-\d{2}).*?(\d{4}-\d{2}-\d{2})/g, function (_, d1, d2) {
        var startDate =
        /* @__PURE__ */
        new Date("".concat(d1, "T00:00:00"));
        var endDate =
        /* @__PURE__ */
        new Date("".concat(d2, "T00:00:00"));
        var currentDate = new Date(startDate.getTime());

        for (currentDate; currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 1)) {
          newDates.push(generateDate(currentDate));
        }

        return _;
      });
    }
  });
  return newDates;
};

var transformTime12 = function transformTime12(hour) {
  var oldHour = Number(hour);
  var newHour = String(oldHour);

  if (oldHour === 0) {
    newHour = "12";
  } else if (oldHour === 13) {
    newHour = "01";
  } else if (oldHour === 14) {
    newHour = "02";
  } else if (oldHour === 15) {
    newHour = "03";
  } else if (oldHour === 16) {
    newHour = "04";
  } else if (oldHour === 17) {
    newHour = "05";
  } else if (oldHour === 18) {
    newHour = "06";
  } else if (oldHour === 19) {
    newHour = "07";
  } else if (oldHour === 20) {
    newHour = "08";
  } else if (oldHour === 21) {
    newHour = "09";
  } else if (oldHour === 22) {
    newHour = "10";
  } else if (oldHour === 23) {
    newHour = "11";
  }

  return newHour;
};

var setVariablesDates = function setVariablesDates(self) {
  var _a, _b;

  self.rangeMin = self.settings.range.min;
  self.rangeMax = self.settings.range.max;
  self.rangeDisabled = self.settings.range.disabled ? parserDates(_toConsumableArray(self.settings.range.disabled)) : [];
  self.rangeEnabled = self.settings.range.enabled ? parserDates(_toConsumableArray(self.settings.range.enabled)) : [];
  self.selectedDates = self.settings.selected.dates ? parserDates(_toConsumableArray(self.settings.selected.dates)) : [];
  self.selectedHolidays = self.settings.selected.holidays ? parserDates(_toConsumableArray(self.settings.selected.holidays)) : [];

  if (self.settings.range.disablePast && !self.settings.range.disableAllDays &&
  /* @__PURE__ */
  new Date("".concat(self.settings.range.min, "T00:00:00")) < self.date.today) {
    self.rangeMin = generateDate(self.date.today);
  }

  if (self.settings.range.disableAllDays) {
    self.rangeMin = generateDate(self.date.today);
    self.rangeMax = generateDate(self.date.today);
    (_a = self.rangeDisabled) == null ? void 0 : _a.push(generateDate(self.date.today));
  }

  if (self.rangeEnabled) self.rangeEnabled.sort(function (a, b) {
    return +new Date(a) - +new Date(b);
  });

  if (((_b = self.rangeEnabled) == null ? void 0 : _b[0]) && self.settings.range.disableAllDays) {
    self.rangeMin = self.rangeEnabled[0];
    self.rangeMax = self.rangeEnabled[self.rangeEnabled.length - 1];
  }

  var firstDay =
  /* @__PURE__ */
  new Date("".concat(self.rangeMin, "T00:00:00"));
  var lastDay =
  /* @__PURE__ */
  new Date("".concat(self.rangeMax, "T00:00:00"));
  firstDay.setDate(firstDay.getDate() - 1);
  lastDay.setDate(lastDay.getDate() + 1);
  self.rangeDisabled.push(generateDate(firstDay));
  self.rangeDisabled.push(generateDate(lastDay));

  if (self.settings.selected.month !== null && self.settings.selected.month >= 0 && self.settings.selected.month < 12) {
    self.selectedMonth = self.settings.selected.month;
  } else {
    self.selectedMonth = self.date.today.getMonth();
  }

  if (self.settings.selected.year !== null && self.settings.selected.year >= 0 && self.settings.selected.year <= 9999) {
    self.selectedYear = self.settings.selected.year;
  } else {
    self.selectedYear = self.date.today.getFullYear();
  }

  self.viewYear = self.selectedYear;
  self.dateMin = self.settings.visibility.disabled ?
  /* @__PURE__ */
  new Date("".concat(self.date.min, "T00:00:00")) :
  /* @__PURE__ */
  new Date("".concat(self.rangeMin, "T00:00:00"));
  self.dateMax = self.settings.visibility.disabled ?
  /* @__PURE__ */
  new Date("".concat(self.date.max, "T00:00:00")) :
  /* @__PURE__ */
  new Date("".concat(self.rangeMax, "T00:00:00"));
  var time12 = self.settings.selection.time === true || self.settings.selection.time === 12;

  if (time12 || self.settings.selection.time === 24) {
    self.userTime = false;

    if (typeof self.settings.selected.time === "string") {
      var regExr = time12 ? /^([0-9]|0[1-9]|1[0-2]):([0-5][0-9])|(AM|PM)/g : /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])/g;
      self.settings.selected.time.replace(regExr, function (_, p1, p2, p3) {
        if (p1 && p2) {
          self.userTime = true;
          self.selectedHours = p1;
          self.selectedMinutes = p2;
        }

        if (p3 && time12) {
          self.selectedKeeping = p3;
        } else if (time12) {
          self.selectedKeeping = "AM";
        }

        return "";
      });
    }

    if (!self.userTime && time12) {
      self.selectedHours = transformTime12(String(self.date.today.getHours()));
      self.selectedMinutes = String(self.date.today.getMinutes());
      self.selectedKeeping = Number(self.date.today.getHours()) >= 12 ? "PM" : "AM";
    } else if (!self.userTime) {
      self.selectedHours = String(self.date.today.getHours());
      self.selectedMinutes = String(self.date.today.getMinutes());
    }

    self.selectedHours = Number(self.selectedHours) < 10 ? "0".concat(Number(self.selectedHours)) : "".concat(self.selectedHours);
    self.selectedMinutes = Number(self.selectedMinutes) < 10 ? "0".concat(Number(self.selectedMinutes)) : "".concat(self.selectedMinutes);
    self.selectedTime = "".concat(self.selectedHours, ":").concat(self.selectedMinutes).concat(self.selectedKeeping ? " ".concat(self.selectedKeeping) : "");
  } else if (self.settings.selection.time) {
    self.settings.selection.time = false;
    console.error("The value of the time property can be: false, true, 12 or 24.");
  }

  if (self.type !== "multiple") return;

  if (self.months === 1) {
    console.warn("The value of the «months» parameter cannot be less than «2», the minimum available value will be initialized.");
    self.correctMonths = 2;
  } else if (self.months > 12) {
    console.warn("The value of the «months» parameter cannot be greater than «12», the maximum available value will be initialized.");
    self.correctMonths = 12;
  } else {
    self.correctMonths = self.months;
  }
};

var controlArrows = function controlArrows(self) {
  if (!["default", "multiple", "year"].includes(self.currentType)) return;
  var arrowPrev = self.HTMLElement.querySelector(".".concat(self.CSSClasses.arrowPrev));
  var arrowNext = self.HTMLElement.querySelector(".".concat(self.CSSClasses.arrowNext));
  if (!arrowPrev || !arrowNext) return;

  var defaultControl = function defaultControl() {
    if (!self.dateMin || !self.dateMax) return;
    var jumpDateMin =
    /* @__PURE__ */
    new Date("".concat(generateDate(new Date(self.selectedYear, self.selectedMonth, 1)), "T00:00:00"));
    var jumpDateMax = new Date(jumpDateMin.getTime());
    jumpDateMin.setMonth(jumpDateMin.getMonth() - self.jumpMonths);
    jumpDateMax.setMonth(jumpDateMax.getMonth() + self.jumpMonths);

    if (!self.settings.selection.month || jumpDateMin.getFullYear() < self.dateMin.getFullYear() || jumpDateMin.getFullYear() === self.dateMin.getFullYear() && jumpDateMin.getMonth() < self.dateMin.getMonth()) {
      arrowPrev.style.visibility = "hidden";
    } else {
      arrowPrev.style.visibility = "";
    }

    if (!self.settings.selection.month || jumpDateMax.getFullYear() > self.dateMax.getFullYear() || jumpDateMax.getFullYear() === self.dateMax.getFullYear() && jumpDateMax.getMonth() > self.dateMax.getMonth()) {
      arrowNext.style.visibility = "hidden";
    } else {
      arrowNext.style.visibility = "";
    }
  };

  var yearControl = function yearControl() {
    if (!self.dateMin || !self.dateMax || self.viewYear === void 0) return;

    if (self.dateMin.getFullYear() && self.viewYear - 7 <= self.dateMin.getFullYear()) {
      arrowPrev.style.visibility = "hidden";
    } else {
      arrowPrev.style.visibility = "";
    }

    if (self.dateMax.getFullYear() && self.viewYear + 7 >= self.dateMax.getFullYear()) {
      arrowNext.style.visibility = "hidden";
    } else {
      arrowNext.style.visibility = "";
    }
  };

  if (self.currentType === "default" || self.currentType === "multiple") defaultControl();
  if (self.currentType === "year") yearControl();
};

var createPopup = function createPopup(self, daysEl) {
  if (!self.popups) return;
  Object.keys(self.popups).forEach(function (date) {
    var _a;

    var dayBtnEl = daysEl.querySelector("[data-calendar-day=\"".concat(date, "\"]"));

    if (dayBtnEl) {
      var dayInfo = (_a = self.popups) == null ? void 0 : _a[date];
      if (dayInfo == null ? void 0 : dayInfo.modifier) dayInfo.modifier.trim().split(" ").forEach(function (cl) {
        dayBtnEl.classList.add(cl);
      });
      if (dayInfo == null ? void 0 : dayInfo.html) dayBtnEl.parentNode.innerHTML += "<div class=\"".concat(self.CSSClasses.dayPopup, "\">").concat(dayInfo.html, "</div>");
    }
  });
};

var getWeekNumber = function getWeekNumber(date, iso8601) {
  if (!date) return null;
  var day =
  /* @__PURE__ */
  new Date("".concat(date, "T00:00:00")).getDate();
  var month =
  /* @__PURE__ */
  new Date("".concat(date, "T00:00:00")).getMonth();
  var year =
  /* @__PURE__ */
  new Date("".concat(date, "T00:00:00")).getFullYear();
  var currentDate = new Date(year, month, day);
  var dayNum = iso8601 ? currentDate.getDay() || 7 : currentDate.getDay();
  currentDate.setDate(currentDate.getDate() + 4 - dayNum);
  var yearStart = new Date(currentDate.getFullYear(), 0, 1);
  var weekNumber = Math.ceil(((+currentDate - +yearStart) / 864e5 + 1) / 7);
  return {
    year: year,
    week: weekNumber
  };
};

var createWeekNumbers = function createWeekNumbers(self, firstDayWeek, daysSelectedMonth, weekNumbersEl, daysEl) {
  if (!self.settings.visibility.weekNumbers) return;
  var dayEls = daysEl.querySelectorAll(".".concat(self.CSSClasses.day));
  weekNumbersEl.innerHTML = "";
  var countWeek = Math.ceil((firstDayWeek + daysSelectedMonth) / 7);
  var weekNumbersTitleEl = document.createElement("b");
  weekNumbersTitleEl.className = self.CSSClasses.weekNumbersTitle;
  weekNumbersTitleEl.innerText = "#";
  weekNumbersEl.append(weekNumbersTitleEl);
  var weekNumbersContentEl = document.createElement("div");
  weekNumbersContentEl.className = self.CSSClasses.weekNumbersContent;
  weekNumbersEl.append(weekNumbersContentEl);
  var templateWeekNumberEl = document.createElement("span");
  templateWeekNumberEl.className = self.CSSClasses.weekNumber;

  for (var i = 0; i < countWeek; i++) {
    var dayBtnEl = null;

    if (i === 0) {
      dayBtnEl = dayEls[6].querySelector(".".concat(self.CSSClasses.dayBtn));
    } else {
      dayBtnEl = dayEls[i * 7].querySelector(".".concat(self.CSSClasses.dayBtn));
    }

    var weekNumber = getWeekNumber(dayBtnEl.dataset.calendarDay, self.settings.iso8601);
    if (!weekNumber) return;
    var weekNumberEl = templateWeekNumberEl.cloneNode(true);
    weekNumberEl.innerText = "".concat(weekNumber.week);
    weekNumberEl.dataset.calendarYearWeek = "".concat(weekNumber.year);
    weekNumbersContentEl.append(weekNumberEl);
  }
};

var createDays = function createDays(self) {
  var _a, _b;

  var daysEls = self.HTMLElement.querySelectorAll(".".concat(self.CSSClasses.days));
  var weekNumbersEls = self.HTMLElement.querySelectorAll(".".concat(self.CSSClasses.weekNumbers));
  var initDate = new Date(self.selectedYear, self.selectedMonth, 1);
  var templateDayEl = document.createElement("div");
  var templateDayBtnEl = document.createElement("button");
  templateDayEl.className = self.CSSClasses.day;
  templateDayBtnEl.className = self.CSSClasses.dayBtn;
  templateDayBtnEl.type = "button";
  (_a = self.selectedDates) == null ? void 0 : _a.sort(function (a, b) {
    return +new Date(a) - +new Date(b);
  });
  daysEls.forEach(function (_, index) {
    var selectedMonth = new Date(initDate.setMonth(self.selectedMonth + index)).getMonth();
    var selectedYear = new Date(initDate.setFullYear(self.selectedYear, self.selectedMonth + index)).getFullYear();
    var firstDay = new Date(selectedYear, selectedMonth, 1);
    var daysSelectedMonth = new Date(selectedYear, selectedMonth + 1, 0).getDate();
    var firstDayWeek = Number(firstDay.getDay());
    if (self.settings.iso8601) firstDayWeek = Number((firstDay.getDay() !== 0 ? firstDay.getDay() : 7) - 1);

    if (self.settings.selection.day && ["single", "multiple", "multiple-ranged"].includes(self.settings.selection.day)) {
      daysEls[index].classList.add(self.CSSClasses.daysSelecting);
    }

    daysEls[index].innerHTML = "";

    var setDayModifier = function setDayModifier(dayEl, dayBtnEl, dayID, date, otherMonth) {
      if (self.rangeMin > date || self.rangeMax < date) {
        dayBtnEl.classList.add(self.CSSClasses.dayBtnDisabled);
        dayBtnEl.tabIndex = -1;
      }

      if (self.settings.visibility.weekend && (dayID === 0 || dayID === 6)) {
        dayBtnEl.classList.add(self.CSSClasses.dayBtnWeekend);
      }

      if (Array.isArray(self.selectedHolidays)) {
        self.selectedHolidays.forEach(function (holiday) {
          if (holiday === date) {
            dayBtnEl.classList.add(self.CSSClasses.dayBtnHoliday);
          }
        });
      }

      var thisToday = self.date.today.getDate();
      var thisMonth = self.date.today.getMonth() + 1;
      thisToday = thisToday < 10 ? "0".concat(thisToday) : thisToday;
      thisMonth = thisMonth < 10 ? "0".concat(thisMonth) : thisMonth;
      var thisDay = "".concat(self.date.today.getFullYear(), "-").concat(thisMonth, "-").concat(thisToday);

      if (self.settings.visibility.today && dayBtnEl.dataset.calendarDay === thisDay) {
        dayBtnEl.classList.add(self.CSSClasses.dayBtnToday);
      }

      if (self.selectedDates && self.selectedDates.indexOf(date) === 0) {
        if (self.settings.selection.day === "multiple-ranged" && self.selectedDates.length > 1) {
          dayEl.classList.add(self.CSSClasses.daySelectedFirst);
        } else {
          dayEl.classList.add(self.CSSClasses.daySelected);
        }

        dayBtnEl.classList.add(self.CSSClasses.dayBtnSelected);
      } else if (self.selectedDates && self.selectedDates[0] && self.selectedDates.indexOf(date) === self.selectedDates.length - 1) {
        dayEl.classList.add(self.CSSClasses.daySelected);

        if (self.settings.selection.day === "multiple-ranged") {
          dayEl.classList.add(self.CSSClasses.daySelectedLast);
        } else {
          dayEl.classList.add(self.CSSClasses.daySelected);
        }

        dayBtnEl.classList.add(self.CSSClasses.dayBtnSelected);
      } else if (self.selectedDates && self.selectedDates.indexOf(date) > 0 && self.settings.selection.day === "multiple-ranged") {
        dayEl.classList.add(self.CSSClasses.daySelectedIntermediate);
        dayBtnEl.classList.add(self.CSSClasses.dayBtnSelected);
        dayBtnEl.classList.add(self.CSSClasses.dayBtnIntermediate);
      } else if (self.selectedDates && self.selectedDates.indexOf(date) > 0) {
        dayEl.classList.add(self.CSSClasses.daySelected);
        dayBtnEl.classList.add(self.CSSClasses.dayBtnSelected);
      }

      if (Array.isArray(self.rangeDisabled) && self.rangeDisabled[0]) {
        self.rangeDisabled.forEach(function (dateDisabled) {
          if (dateDisabled === date) {
            dayBtnEl.classList.add(self.CSSClasses.dayBtnDisabled);
            dayBtnEl.tabIndex = -1;
          }
        });
      }

      if (!self.settings.selection.month && otherMonth) {
        dayBtnEl.classList.add(self.CSSClasses.dayBtnDisabled);
        dayBtnEl.tabIndex = -1;
      }

      if (!self.settings.selection.year &&
      /* @__PURE__ */
      new Date("".concat(date, "T00:00:00")).getFullYear() !== selectedYear) {
        dayBtnEl.classList.add(self.CSSClasses.dayBtnDisabled);
        dayBtnEl.tabIndex = -1;
      }
    };

    var createDay = function createDay(dayText, dayID, date, otherMonth, modifier) {
      var _a2, _b2, _c, _d, _e, _f, _g, _h, _i;

      var dayEl = templateDayEl.cloneNode(true);
      var dayBtnEl = templateDayBtnEl.cloneNode(true);
      if (modifier) dayBtnEl.classList.add(modifier);
      dayBtnEl.innerText = dayText;
      dayBtnEl.dataset.calendarDay = date;

      if (self.settings.visibility.weekNumbers) {
        var weekNumber = getWeekNumber(date, self.settings.iso8601);
        if (!weekNumber) return;
        dayBtnEl.dataset.calendarWeekNumber = "".concat(weekNumber.week);
      }

      if (((_a2 = self.rangeEnabled) == null ? void 0 : _a2[0]) && self.settings.range.disableAllDays && !((_b2 = self.rangeDisabled) == null ? void 0 : _b2.includes(date))) {
        (_c = self.rangeDisabled) == null ? void 0 : _c.push(date);
      }

      if (((_d = self.rangeEnabled) == null ? void 0 : _d[0]) && ((_e = self.rangeDisabled) == null ? void 0 : _e.includes(date))) {
        self.rangeDisabled = (_f = self.rangeDisabled) == null ? void 0 : _f.filter(function (d) {
          var _a3;

          return !((_a3 = self.rangeEnabled) == null ? void 0 : _a3.includes(d));
        });
      }

      if (((_g = self.settings.range.disableWeekday) == null ? void 0 : _g.includes(dayID)) && !((_h = self.rangeDisabled) == null ? void 0 : _h.includes(date))) {
        (_i = self.rangeDisabled) == null ? void 0 : _i.push(date);
      }

      setDayModifier(dayEl, dayBtnEl, dayID, date, otherMonth);

      if (otherMonth) {
        if (self.settings.visibility.daysOutside) dayEl.append(dayBtnEl);
      } else {
        dayEl.append(dayBtnEl);
      }

      daysEls[index].append(dayEl);
      if (self.actions.getDays) self.actions.getDays(Number(dayText), date, dayEl, dayBtnEl);
    };

    var prevMonth = function prevMonth() {
      var prevMonthDays = new Date(selectedYear, selectedMonth, 0).getDate();
      var day = prevMonthDays - firstDayWeek;
      var year = selectedYear;
      var month = selectedMonth;

      if (selectedMonth === 0) {
        month = self.locale.months.length;
        year = selectedYear - 1;
      } else if (selectedMonth < 10) {
        month = "0".concat(selectedMonth);
      }

      for (var i = 0; i < firstDayWeek; i++) {
        day += 1;
        var date = "".concat(year, "-").concat(month, "-").concat(day);
        var dayIDCurrent = new Date(selectedYear, selectedMonth, day - 1);
        var prevMonthID = dayIDCurrent.getMonth() - 1;
        var dayID = new Date(selectedYear, prevMonthID, day).getDay();
        createDay(String(day), dayID, date, true, self.CSSClasses.dayBtnPrev);
      }
    };

    var currentMonth = function currentMonth() {
      for (var i = 1; i <= daysSelectedMonth; i++) {
        var day = new Date(selectedYear, selectedMonth, i);
        var date = generateDate(day);
        var dayID = day.getDay();
        createDay(String(i), dayID, date, false, null);
      }
    };

    var nextMonth = function nextMonth() {
      var total = firstDayWeek + daysSelectedMonth;
      var rows = Math.ceil(total / self.locale.weekday.length);
      var nextDays = self.locale.weekday.length * rows - total;
      var year = selectedYear;
      var month = String(selectedMonth + 2);

      if (selectedMonth + 1 === self.locale.months.length) {
        month = "01";
        year = selectedYear + 1;
      } else if (selectedMonth + 2 < 10) {
        month = "0".concat(selectedMonth + 2);
      }

      for (var i = 1; i <= nextDays; i++) {
        var day = i < 10 ? "0".concat(i) : String(i);
        var date = "".concat(year, "-").concat(month, "-").concat(day);
        var dayIDCurrent = new Date(selectedYear, selectedMonth, i);
        var nextMonthID = dayIDCurrent.getMonth() + 1;
        var dayID = new Date(selectedYear, nextMonthID, i).getDay();
        createDay(String(i), dayID, date, true, self.CSSClasses.dayBtnNext);
      }
    };

    prevMonth();
    currentMonth();
    nextMonth();
    createPopup(self, daysEls[index]);
    createWeekNumbers(self, firstDayWeek, daysSelectedMonth, weekNumbersEls[index], daysEls[index]);
  });
  (_b = self.rangeDisabled) == null ? void 0 : _b.sort(function (a, b) {
    return +new Date(a) - +new Date(b);
  });
};

var ArrowPrev = function ArrowPrev(self) {
  return "\n\t<button type=\"button\"\n\t\tclass=\"".concat(self.CSSClasses.arrow, " ").concat(self.CSSClasses.arrowPrev, "\"\n\t\tdata-calendar-arrow=\"prev\"\n\t\ttitle=\"Prev\">\n\t</button>\n");
};

var ArrowNext = function ArrowNext(self) {
  return "\n\t<button type=\"button\"\n\tclass=\"".concat(self.CSSClasses.arrow, " ").concat(self.CSSClasses.arrowNext, "\"\n\tdata-calendar-arrow=\"next\"\n\ttitle=\"Next\">\n\t</button>\n");
};

var Month = function Month(self) {
  return "\n\t<button type=\"button\"\n\t\tclass=\"".concat(self.CSSClasses.month, "\"\n\t\tdata-calendar-selected-month>\n\t</button>\n");
};

var Year = function Year(self) {
  return "\n\t<button type=\"button\"\n\t\tclass=\"".concat(self.CSSClasses.year, "\"\n\t\tdata-calendar-selected-year>\n\t</button>\n");
};

var Week = function Week(self) {
  return "\n\t<div class=\"".concat(self.CSSClasses.week, "\"></div>\n");
};

var Days = function Days(self) {
  return "\n\t<div class=\"".concat(self.CSSClasses.days, "\"></div>\n");
};

var Months = function Months(self) {
  return "\n\t<div class=\"".concat(self.CSSClasses.months, "\"></div>\n");
};

var Years = function Years(self) {
  return "\n\t<div class=\"".concat(self.CSSClasses.years, "\"></div>\n");
};

var WeekNumbers = function WeekNumbers(self) {
  return self.settings.visibility.weekNumbers ? "\n\t<div class=\"".concat(self.CSSClasses.weekNumbers, "\"></div>\n") : "";
};

var ControlTime = function ControlTime(self) {
  return self.settings.selection.time ? "\n\t<div class=\"".concat(self.CSSClasses.time, "\"></div>\n") : "";
};

var getComponent = function getComponent(pattern) {
  var FC = null;

  switch (pattern) {
    case "ArrowPrev":
      FC = ArrowPrev;
      break;

    case "ArrowNext":
      FC = ArrowNext;
      break;

    case "Month":
      FC = Month;
      break;

    case "Year":
      FC = Year;
      break;

    case "Week":
      FC = Week;
      break;

    case "Days":
      FC = Days;
      break;

    case "Months":
      FC = Months;
      break;

    case "Years":
      FC = Years;
      break;

    case "WeekNumbers":
      FC = WeekNumbers;
      break;

    case "ControlTime":
      FC = ControlTime;
      break;
  }

  return FC;
};

var DOMParser = function DOMParser(self, template) {
  return template.replace(/<#(.*?)\/>/g, function (_, p1) {
    var component = getComponent(p1.replace(/[\s\n\t]/g, ""));
    return component ? component(self) : "";
  }).replace(/[\n\t]/g, "");
};

var MultipleParser = function MultipleParser(self, template) {
  return template.replace(/<#Multiple>(.*?)<#\/Multiple>/g, function (_, p1) {
    var content = "";

    for (var i = 0; i < self.correctMonths; i++) {
      content += p1;
    }

    return content;
  }).replace(/[\n\t]/g, "");
};

var createDOM = function createDOM(self, target) {
  var calendarElement = self.HTMLElement;
  calendarElement.classList.add(self.CSSClasses.calendar);

  var switcherTypeMultiple = function switcherTypeMultiple(columnClass, DOMTemplates) {
    if (!target) return;
    var controls = self.HTMLElement.querySelector(".".concat(self.CSSClasses.controls));
    if (controls) self.HTMLElement.removeChild(controls);
    var grid = self.HTMLElement.querySelector(".".concat(self.CSSClasses.grid));
    grid.classList.add(self.CSSClasses.gridDisabled);
    var columnElement = target.closest(".".concat(self.CSSClasses.column));
    columnElement.classList.add(columnClass);
    columnElement.innerHTML = DOMParser(self, DOMTemplates);
  };

  switch (self.currentType) {
    case "default":
      calendarElement.classList.add(self.CSSClasses.calendarDefault);
      calendarElement.classList.remove(self.CSSClasses.calendarMonth);
      calendarElement.classList.remove(self.CSSClasses.calendarYear);
      calendarElement.innerHTML = DOMParser(self, self.DOMTemplates.default);
      break;

    case "multiple":
      if (!self.correctMonths) break;
      calendarElement.classList.add(self.CSSClasses.calendarMultiple);
      calendarElement.classList.remove(self.CSSClasses.calendarMonth);
      calendarElement.classList.remove(self.CSSClasses.calendarYear);
      calendarElement.innerHTML = MultipleParser(self, DOMParser(self, self.DOMTemplates.multiple));
      break;

    case "month":
      if (self.type === "multiple") {
        switcherTypeMultiple(self.CSSClasses.columnMonth, self.DOMTemplates.month);
        break;
      }

      calendarElement.classList.remove(self.CSSClasses.calendarDefault);
      calendarElement.classList.add(self.CSSClasses.calendarMonth);
      calendarElement.classList.remove(self.CSSClasses.calendarYear);
      calendarElement.innerHTML = DOMParser(self, self.DOMTemplates.month);
      break;

    case "year":
      if (self.type === "multiple") {
        switcherTypeMultiple(self.CSSClasses.columnYear, self.DOMTemplates.year);
        break;
      }

      calendarElement.classList.remove(self.CSSClasses.calendarDefault);
      calendarElement.classList.remove(self.CSSClasses.calendarMonth);
      calendarElement.classList.add(self.CSSClasses.calendarYear);
      calendarElement.innerHTML = DOMParser(self, self.DOMTemplates.year);
      break;
  }
};

var showMonth = function showMonth(self) {
  var months = self.HTMLElement.querySelectorAll("[data-calendar-selected-month]");
  if (!months[0] || self.selectedMonth === void 0) return;
  var initDate = new Date(self.selectedYear, self.selectedMonth, 1);
  months.forEach(function (_, index) {
    var selectedMonth = new Date(initDate.setMonth(self.selectedMonth + index)).getMonth();
    months[index].dataset.calendarSelectedMonth = String(selectedMonth);
    months[index].innerText = self.locale.months[selectedMonth];

    if (self.settings.selection.month === false || self.settings.selection.month === "only-arrows") {
      months[index].tabIndex = -1;
      months[index].classList.add(self.CSSClasses.monthDisabled);
    } else {
      months[index].tabIndex = 0;
      months[index].classList.remove(self.CSSClasses.monthDisabled);
    }
  });
};

var showYear = function showYear(self) {
  var years = self.HTMLElement.querySelectorAll("[data-calendar-selected-year]");
  if (!years || self.selectedMonth === void 0) return;
  var initDate = new Date(self.selectedYear, self.selectedMonth, 1);
  years.forEach(function (_, index) {
    var selectedYear = new Date(initDate.setFullYear(self.selectedYear, self.selectedMonth + index)).getFullYear();
    years[index].dataset.calendarSelectedYear = String(selectedYear);
    years[index].innerText = String(selectedYear);

    if (self.settings.selection.year === false || self.settings.selection.year === "only-arrows") {
      years[index].tabIndex = -1;
      years[index].classList.add(self.CSSClasses.yearDisabled);
    } else {
      years[index].tabIndex = 0;
      years[index].classList.remove(self.CSSClasses.yearDisabled);
    }
  });
};

var createMonths = function createMonths(self, target) {
  var _a;

  var selectedMonth = (target == null ? void 0 : target.dataset.calendarSelectedMonth) ? Number(target.dataset.calendarSelectedMonth) : self.selectedMonth;
  var yearEl = (_a = target == null ? void 0 : target.closest(".".concat(self.CSSClasses.column))) == null ? void 0 : _a.querySelector(".".concat(self.CSSClasses.year));
  var selectedYear = yearEl ? Number(yearEl.dataset.calendarSelectedYear) : self.selectedYear;
  self.currentType = "month";
  createDOM(self, target);
  showMonth(self);
  showYear(self);
  var monthsEl = self.HTMLElement.querySelector(".".concat(self.CSSClasses.months));
  if (!self.dateMin || !self.dateMax || !monthsEl) return;
  if (self.settings.selection.month) monthsEl.classList.add(self.CSSClasses.monthsSelecting);
  var activeMonthsID = self.jumpMonths > 1 ? self.locale.months.map(function (_, i) {
    return selectedMonth - self.jumpMonths * i;
  }).concat(self.locale.months.map(function (_, i) {
    return selectedMonth + self.jumpMonths * i;
  })).filter(function (monthID) {
    return monthID >= 0 && monthID <= 12;
  }) : Array.from(Array(12).keys());
  var templateMonthEl = document.createElement("button");
  templateMonthEl.type = "button";
  templateMonthEl.className = self.CSSClasses.monthsMonth;

  var columnID = function columnID() {
    if (self.type !== "multiple") return 0;
    var columnEls = self.HTMLElement.querySelectorAll(".".concat(self.CSSClasses.column));

    var indexColumn = _toConsumableArray(columnEls).findIndex(function (column) {
      return column.classList.contains("".concat(self.CSSClasses.columnMonth));
    });

    return indexColumn > 0 ? indexColumn : 0;
  };

  for (var i = 0; i < self.locale.months.length; i++) {
    var month = self.locale.months[i];
    var monthEl = templateMonthEl.cloneNode(true);

    if (i === selectedMonth) {
      monthEl.classList.add(self.CSSClasses.monthsMonthSelected);
    }

    if (i < self.dateMin.getMonth() + columnID() && selectedYear <= self.dateMin.getFullYear() || i > self.dateMax.getMonth() + columnID() && selectedYear >= self.dateMax.getFullYear() || i !== selectedMonth && !activeMonthsID.includes(i)) {
      monthEl.classList.add(self.CSSClasses.monthsMonthDisabled);
      monthEl.tabIndex = -1;
    }

    monthEl.dataset.calendarMonth = String(i);
    monthEl.title = "".concat(month);
    monthEl.innerText = "".concat(self.settings.visibility.monthShort ? month.substring(0, 3) : month);
    monthsEl.append(monthEl);
  }
};

var transformTime24 = function transformTime24(hour, keeping) {
  var oldHour = Number(hour);
  var newHour = String(oldHour);

  if (keeping === "AM") {
    if (oldHour === 12) {
      newHour = "00";
    }
  } else if (keeping === "PM") {
    if (oldHour === 1) {
      newHour = "13";
    } else if (oldHour === 2) {
      newHour = "14";
    } else if (oldHour === 3) {
      newHour = "15";
    } else if (oldHour === 4) {
      newHour = "16";
    } else if (oldHour === 5) {
      newHour = "17";
    } else if (oldHour === 6) {
      newHour = "18";
    } else if (oldHour === 7) {
      newHour = "19";
    } else if (oldHour === 8) {
      newHour = "20";
    } else if (oldHour === 9) {
      newHour = "21";
    } else if (oldHour === 10) {
      newHour = "22";
    } else if (oldHour === 11) {
      newHour = "23";
    }
  }

  return newHour;
};

var controlTime = function controlTime(self, keepingTime) {
  var rangeHours = self.HTMLElement.querySelector(".".concat(self.CSSClasses.timeRange, " input[name=\"hours\"]"));
  var rangeMinutes = self.HTMLElement.querySelector(".".concat(self.CSSClasses.timeRange, " input[name=\"minutes\"]"));
  var inputHours = self.HTMLElement.querySelector(".".concat(self.CSSClasses.timeHours, " input[name=\"hours\"]"));
  var inputMinutes = self.HTMLElement.querySelector(".".concat(self.CSSClasses.timeMinutes, " input[name=\"minutes\"]"));
  var btnKeepingTime = self.HTMLElement.querySelector(".".concat(self.CSSClasses.timeKeeping));

  var mouseoverRange = function mouseoverRange(range, input) {
    range.addEventListener("mouseover", function () {
      return input.classList.add(self.CSSClasses.isFocus);
    });
  };

  var mouseoutRange = function mouseoutRange(range, input) {
    range.addEventListener("mouseout", function () {
      return input.classList.remove(self.CSSClasses.isFocus);
    });
  };

  var setTime = function setTime(e, value, type) {
    if (type === "hours") {
      self.selectedHours = "".concat(value);
    } else if (type === "minutes") {
      self.selectedMinutes = "".concat(value);
    }

    self.selectedTime = "".concat(self.selectedHours, ":").concat(self.selectedMinutes).concat(self.selectedKeeping ? " ".concat(self.selectedKeeping) : "");

    if (self.actions.changeTime) {
      self.actions.changeTime(e, self.selectedTime, self.selectedHours, self.selectedMinutes, self.selectedKeeping);
    }

    if (self.input && self.HTMLInputElement && self.actions.changeToInput) {
      var calendar = {
        hide: function hide() {
          self.HTMLElement.classList.add(self.CSSClasses.calendarHidden);
        },
        show: function show() {
          self.HTMLElement.classList.remove(self.CSSClasses.calendarHidden);
        },
        HTMLInputElement: self.HTMLInputElement,
        HTMLElement: self.HTMLElement
      };
      self.actions.changeToInput(e, calendar, self.selectedDates, self.selectedTime, self.selectedHours, self.selectedMinutes, self.selectedKeeping);
    }
  };

  var changeRange = function changeRange(range, input, type, max) {
    range.addEventListener("input", function (e) {
      var value = Number(e.target.value);
      value = value < 10 ? "0".concat(value) : "".concat(value);

      if (type === "hours" && max === 12) {
        if (Number(e.target.value) < max && Number(e.target.value) > 0) {
          input.value = value;
          self.selectedKeeping = "AM";
          btnKeepingTime.innerText = self.selectedKeeping;
          setTime(e, value, type);
        } else {
          if (Number(e.target.value) === 0) {
            self.selectedKeeping = "AM";
            btnKeepingTime.innerText = "AM";
          } else {
            self.selectedKeeping = "PM";
            btnKeepingTime.innerText = "PM";
          }

          input.value = transformTime12(e.target.value);
          setTime(e, transformTime12(e.target.value), type);
        }
      } else {
        input.value = value;
        setTime(e, value, type);
      }
    });
  };

  var changeInput = function changeInput(range, input, type, max) {
    input.addEventListener("change", function (e) {
      var changeInputEl = e.target;
      var value = Number(changeInputEl.value);
      value = value < 10 ? "0".concat(value) : "".concat(value);

      if (type === "hours" && max === 12) {
        if (changeInputEl.value && Number(changeInputEl.value) <= max && Number(changeInputEl.value) > 0) {
          changeInputEl.value = value;
          range.value = transformTime24(value, self.selectedKeeping);
          setTime(e, value, type);
        } else if (changeInputEl.value && Number(changeInputEl.value) < 24 && (Number(changeInputEl.value) > max || Number(changeInputEl.value) === 0)) {
          if (Number(changeInputEl.value) === 0) {
            self.selectedKeeping = "AM";
            btnKeepingTime.innerText = "AM";
          } else {
            self.selectedKeeping = "PM";
            btnKeepingTime.innerText = "PM";
          }

          changeInputEl.value = transformTime12(changeInputEl.value);
          range.value = value;
          setTime(e, transformTime12(changeInputEl.value), type);
        } else {
          changeInputEl.value = self.selectedHours;
        }
      } else if (changeInputEl.value && Number(changeInputEl.value) <= max && Number(changeInputEl.value) >= 0) {
        changeInputEl.value = value;
        range.value = value;
        setTime(e, value, type);
      } else if (type === "hours") {
        changeInputEl.value = self.selectedHours;
      } else if (type === "minutes") {
        changeInputEl.value = self.selectedMinutes;
      }
    });
  };

  mouseoverRange(rangeHours, inputHours);
  mouseoverRange(rangeMinutes, inputMinutes);
  mouseoutRange(rangeHours, inputHours);
  mouseoutRange(rangeMinutes, inputMinutes);
  changeRange(rangeHours, inputHours, "hours", keepingTime === 24 ? 23 : 12);
  changeRange(rangeMinutes, inputMinutes, "minutes", 0);
  changeInput(rangeHours, inputHours, "hours", keepingTime === 24 ? 23 : 12);
  changeInput(rangeMinutes, inputMinutes, "minutes", 59);
  if (!btnKeepingTime) return;
  btnKeepingTime.addEventListener("click", function (e) {
    if (btnKeepingTime.innerText.includes("AM")) {
      self.selectedKeeping = "PM";
    } else {
      self.selectedKeeping = "AM";
    }

    rangeHours.value = transformTime24(self.selectedHours, self.selectedKeeping);
    setTime(e, self.selectedHours, "hours");
    btnKeepingTime.innerText = self.selectedKeeping;
  });
};

var createTime = function createTime(self) {
  var timeEl = self.HTMLElement.querySelector(".".concat(self.CSSClasses.time));
  if (!timeEl) return;
  var keepingTime = self.settings.selection.time === true ? 12 : self.settings.selection.time;
  var range = self.settings.selection.controlTime === "range";
  timeEl.innerHTML = "\n\t<div class=\"".concat(self.CSSClasses.timeContent, "\">\n\t\t<label class=\"").concat(self.CSSClasses.timeHours, "\">\n\t\t\t<input type=\"text\"\n\t\t\t\tname=\"hours\"\n\t\t\t\tmaxlength=\"2\"\n\t\t\t\tvalue=\"").concat(self.selectedHours, "\"\n\t\t\t\t").concat(range ? "disabled" : "", ">\n\t\t</label>\n\t\t<label class=\"").concat(self.CSSClasses.timeMinutes, "\">\n\t\t\t<input type=\"text\"\n\t\t\t\tname=\"minutes\"\n\t\t\t\tmaxlength=\"2\"\n\t\t\t\tvalue=\"").concat(self.selectedMinutes, "\"\n\t\t\t\t").concat(range ? "disabled" : "", ">\n\t\t</label>\n\t\t").concat(keepingTime === 12 ? "\n\t\t<button type=\"button\"\n\t\t\tclass=\"".concat(self.CSSClasses.timeKeeping, "\"\n\t\t\t").concat(range ? "disabled" : "", ">").concat(self.selectedKeeping, "</button>\n\t\t") : "", "\n\t</div>\n\t<div class=\"").concat(self.CSSClasses.timeRanges, "\">\n\t\t<label class=\"").concat(self.CSSClasses.timeRange, "\">\n\t\t\t<input type=\"range\"\n\t\t\t\tname=\"hours\"\n\t\t\t\tmin=\"0\"\n\t\t\t\tmax=\"23\"\n\t\t\t\tstep=\"").concat(self.settings.selection.stepHours, "\"\n\t\t\t\tvalue=\"").concat(self.selectedKeeping ? transformTime24(self.selectedHours, self.selectedKeeping) : self.selectedHours, "\">\n\t\t</label>\n\t\t<label class=\"").concat(self.CSSClasses.timeRange, "\">\n\t\t\t<input type=\"range\"\n\t\t\t\tname=\"minutes\"\n\t\t\t\tmin=\"0\"\n\t\t\t\tmax=\"59\"\n\t\t\t\tstep=\"").concat(self.settings.selection.stepMinutes, "\"\n\t\t\t\tvalue=\"").concat(self.selectedMinutes, "\">\n\t\t</label>\n\t</div>");
  controlTime(self, keepingTime);
};

var createWeek = function createWeek(self) {
  var weekday = _toConsumableArray(self.locale.weekday);

  if (!weekday[0]) return;
  var weekEls = self.HTMLElement.querySelectorAll(".".concat(self.CSSClasses.week));
  var templateWeekDayEl = document.createElement("b");
  templateWeekDayEl.className = self.CSSClasses.weekDay;
  if (self.settings.iso8601) weekday.push(weekday.shift());
  weekEls.forEach(function (weekEl) {
    weekEl.innerHTML = "";

    for (var i = 0; i < weekday.length; i++) {
      var weekDayName = weekday[i];
      var weekDayEl = templateWeekDayEl.cloneNode(true);

      if (self.settings.visibility.weekend && self.settings.iso8601) {
        if (i === 5 || i === 6) {
          weekDayEl.classList.add(self.CSSClasses.weekDayWeekend);
        }
      } else if (self.settings.visibility.weekend && !self.settings.iso8601) {
        if (i === 0 || i === 6) {
          weekDayEl.classList.add(self.CSSClasses.weekDayWeekend);
        }
      }

      weekDayEl.innerText = "".concat(weekDayName);
      weekEl.append(weekDayEl);
    }
  });
};

var createYears = function createYears(self, target) {
  if (self.viewYear === void 0 || !self.dateMin || !self.dateMax) return;
  var selectedYear = (target == null ? void 0 : target.dataset.calendarSelectedYear) ? Number(target == null ? void 0 : target.dataset.calendarSelectedYear) : self.selectedYear;
  self.currentType = "year";
  createDOM(self, target);
  showMonth(self);
  showYear(self);
  controlArrows(self);
  var yearsEl = self.HTMLElement.querySelector(".".concat(self.CSSClasses.years));
  if (!yearsEl) return;
  if (self.settings.selection.year) yearsEl.classList.add(self.CSSClasses.yearsSelecting);
  var templateYearEl = document.createElement("button");
  templateYearEl.type = "button";
  templateYearEl.className = self.CSSClasses.yearsYear;

  var relationshipID = function relationshipID() {
    if (self.type !== "multiple") return 0;
    return self.selectedYear === selectedYear ? 0 : 1;
  };

  for (var i = self.viewYear - 7; i < self.viewYear + 8; i++) {
    var year = i;
    var yearEl = templateYearEl.cloneNode(true);

    if (year === selectedYear) {
      yearEl.classList.add(self.CSSClasses.yearsYearSelected);
    }

    if (year < self.dateMin.getFullYear() + relationshipID() || year > self.dateMax.getFullYear()) {
      yearEl.classList.add(self.CSSClasses.yearsYearDisabled);
      yearEl.tabIndex = -1;
    }

    yearEl.dataset.calendarYear = String(year);
    yearEl.innerText = "".concat(year);
    yearsEl.append(yearEl);
  }
};

var getLocale = function getLocale(self) {
  if (self.settings.lang === "define") return;
  self.locale.weekday = [];

  for (var i = 0; i < 7; i++) {
    var weekday = new Date(0, 0, i).toLocaleString(self.settings.lang, {
      weekday: "short"
    });
    weekday = "".concat(weekday.charAt(0).toUpperCase()).concat(weekday.substring(1, weekday.length));
    weekday = weekday.replace(/\./, "");
    self.locale.weekday.push(weekday);
  }

  self.locale.months = [];

  for (var _i2 = 0; _i2 < 12; _i2++) {
    var month = new Date(0, _i2).toLocaleString(self.settings.lang, {
      month: "long"
    });
    month = "".concat(month.charAt(0).toUpperCase()).concat(month.substring(1, month.length));
    month = month.replace(/\./, "");
    self.locale.months.push(month);
  }
};

var themes = ["light", "dark", "system"];
var haveListener = false;

var getActiveTheme = function getActiveTheme(htmlEl, attr) {
  var _a;

  var activeTheme = null;

  for (var i = 0; i < themes.length; i++) {
    var theme = themes[i];
    if (theme === "system") return;

    if ((_a = htmlEl.getAttribute(attr)) == null ? void 0 : _a.includes(themes[i])) {
      activeTheme = themes[i];
      break;
    }
  }

  return activeTheme;
};

var set = function set(self, theme) {
  if (!self.HTMLElement) return;

  if (themes.includes(theme)) {
    self.HTMLElement.dataset.calendarTheme = theme;
    return;
  }

  console.error("Incorrect name of theme in settings.visibility.theme");
};

var get = function get(self, supportDarkTheme) {
  if (!supportDarkTheme) {
    set(self, "light");
    return;
  }

  var theme = function theme(e) {
    return e.matches ? "dark" : "light";
  };

  self.HTMLElement.dataset.calendarTheme = theme(supportDarkTheme);

  if (!haveListener) {
    supportDarkTheme.onchange = function (e) {
      if (self.settings.visibility.theme !== "system") return;
      self.HTMLElement.dataset.calendarTheme = theme(e);
    };

    haveListener = true;
  }
};

var track = function track(self, htmlEl, attr) {
  var changes = function changes(mutationsList) {
    for (var i = 0; i < mutationsList.length; i++) {
      var record = mutationsList[i];

      if (record.attributeName === attr) {
        var activeTheme = getActiveTheme(htmlEl, attr);
        if (activeTheme) set(self, activeTheme);
        break;
      }
    }
  };

  var observer = new MutationObserver(changes);
  observer.observe(htmlEl, {
    attributes: true
  });
};

var detect = function detect(self, supportDarkTheme) {
  if (!self.HTMLElement) return;
  var detectedThemeEl = self.settings.visibility.themeDetect ? document.querySelector(self.settings.visibility.themeDetect) : false;

  if (!detectedThemeEl) {
    get(self, supportDarkTheme);
    return;
  }

  var attr = self.settings.visibility.themeDetect.replace(/^.*\[(.+)\]/g, function (_, p1) {
    return p1;
  });
  var strValues = detectedThemeEl.hasAttribute(attr);

  if (!attr || !strValues) {
    get(self, supportDarkTheme);
    return;
  }

  var activeTheme = getActiveTheme(detectedThemeEl, attr);

  if (activeTheme) {
    set(self, activeTheme);
    track(self, detectedThemeEl, attr);
  } else {
    get(self, supportDarkTheme);
  }
};

var setTheme = function setTheme(self) {
  if (!self.HTMLElement) return;
  var supportDarkTheme;

  if (window.matchMedia("(prefers-color-scheme)").media !== "not all") {
    supportDarkTheme = window.matchMedia("(prefers-color-scheme: dark)");
  }

  if (self.settings.visibility.theme === "system") {
    detect(self, supportDarkTheme);
  } else {
    set(self, self.settings.visibility.theme);
  }
};

var mainMethod = function mainMethod(self) {
  var typeMapper = {
    default: function _default() {
      createWeek(self);
      createDays(self);
    },
    multiple: function multiple() {
      createWeek(self);
      createDays(self);
    },
    month: function month() {
      createMonths(self);
    },
    year: function year() {
      createYears(self);
    }
  };
  setTheme(self);
  getLocale(self);
  createDOM(self);
  showMonth(self);
  showYear(self);
  controlArrows(self);
  createTime(self);
  typeMapper[self.currentType]();
};

var resetCalendar = function resetCalendar(self) {
  setVariablesDates(self);
  mainMethod(self);
};

var updateCalendar = function updateCalendar(self) {
  var _a;

  var tempSelectedDates = null;
  var tempSelectedMonth = null;
  var tempSelectedYear = null;

  if (!((_a = self.settings.selected.dates) == null ? void 0 : _a[0])) {
    tempSelectedDates = self.settings.selected.dates;
    self.settings.selected.dates = self.selectedDates;
  }

  if (!self.settings.selected.month) {
    tempSelectedMonth = self.settings.selected.month;
    self.settings.selected.month = self.selectedMonth;
  }

  if (!self.settings.selected.year) {
    tempSelectedYear = self.settings.selected.year;
    self.settings.selected.year = self.selectedYear;
  }

  setVariablesDates(self);
  mainMethod(self);
  self.settings.selected.dates = tempSelectedDates;
  self.settings.selected.month = tempSelectedMonth;
  self.settings.selected.year = tempSelectedYear;
};

var currentSelf$1 = null;

var documentClickEvent = function documentClickEvent(e) {
  if (!currentSelf$1) return;
  if (e.target.closest(".".concat(currentSelf$1.CSSClasses.calendar, ".").concat(currentSelf$1.CSSClasses.calendarToInput))) return;
  document.querySelectorAll(".".concat(currentSelf$1.CSSClasses.calendar, ".").concat(currentSelf$1.CSSClasses.calendarToInput)).forEach(function (calendar) {
    calendar.classList.add(currentSelf$1.CSSClasses.calendarHidden);
  });
  document.removeEventListener("click", documentClickEvent, {
    capture: true
  });
};

var handlerInput = function handlerInput(self) {
  var _a;

  if (!self || !self.input) return;
  currentSelf$1 = self;
  (_a = self.HTMLInputElement) == null ? void 0 : _a.addEventListener("click", function () {
    if (self.HTMLElement && self.HTMLInputElement) {
      self.HTMLElement.style.left = "".concat(self.HTMLInputElement.offsetLeft, "px");
      self.HTMLElement.style.top = "".concat(self.HTMLInputElement.offsetTop + self.HTMLInputElement.clientHeight, "px");
      self.HTMLElement.classList.remove(self.CSSClasses.calendarHidden);
    }

    document.addEventListener("click", documentClickEvent, {
      capture: true
    });
  });
};

var changeMonth = function changeMonth(self, route) {
  if (self.selectedMonth === void 0 || self.selectedYear === void 0) return;
  var jumpDate =
  /* @__PURE__ */
  new Date("".concat(generateDate(new Date(self.selectedYear, self.selectedMonth, 1)), "T00:00:00"));

  switch (route) {
    case "prev":
      jumpDate.setMonth(jumpDate.getMonth() - self.jumpMonths);
      break;

    case "next":
      jumpDate.setMonth(jumpDate.getMonth() + self.jumpMonths);
      break;
  }

  self.selectedMonth = jumpDate.getMonth();
  self.selectedYear = jumpDate.getFullYear();
  showMonth(self);
  showYear(self);
  controlArrows(self);
  createDays(self);
};

var currentSelf = null;

var removeHover = function removeHover() {
  var _a;

  if (!currentSelf) return;
  var daysEl = (_a = currentSelf.HTMLElement) == null ? void 0 : _a.querySelectorAll(".".concat(currentSelf.CSSClasses.dayBtnHover));
  if (daysEl) daysEl.forEach(function (d) {
    return d.classList.remove(currentSelf.CSSClasses.dayBtnHover);
  });
};

var addHover = function addHover(day) {
  var _a;

  if (!currentSelf || !currentSelf.selectedDates) return;
  var date = generateDate(day);
  if (currentSelf.rangeDisabled && currentSelf.rangeDisabled.includes(date)) return;
  var dayEls = (_a = currentSelf.HTMLElement) == null ? void 0 : _a.querySelectorAll("[data-calendar-day=\"".concat(date, "\"]"));
  dayEls == null ? void 0 : dayEls.forEach(function (dayEl) {
    dayEl.classList.add(currentSelf.CSSClasses.dayBtnHover);
  });
};

var hoverDaysEvent = function hoverDaysEvent(e) {
  if (!e.target || !currentSelf || !currentSelf.selectedDates) return;

  if (!e.target.closest(".".concat(currentSelf.CSSClasses.days))) {
    removeHover();
    return;
  }

  var date = e.target.dataset.calendarDay;
  if (!date) return;
  removeHover();
  var startDate = new Date(
  /* @__PURE__ */
  new Date("".concat(currentSelf.selectedDates[0], "T00:00:00")).getFullYear(),
  /* @__PURE__ */
  new Date("".concat(currentSelf.selectedDates[0], "T00:00:00")).getMonth(),
  /* @__PURE__ */
  new Date("".concat(currentSelf.selectedDates[0], "T00:00:00")).getDate());
  var endDate = new Date(
  /* @__PURE__ */
  new Date("".concat(date, "T00:00:00")).getFullYear(),
  /* @__PURE__ */
  new Date("".concat(date, "T00:00:00")).getMonth(),
  /* @__PURE__ */
  new Date("".concat(date, "T00:00:00")).getDate());

  if (endDate > startDate) {
    for (var i = startDate; i <= endDate; i.setDate(i.getDate() + 1)) {
      addHover(i);
    }
  } else {
    for (var _i3 = startDate; _i3 >= endDate; _i3.setDate(_i3.getDate() - 1)) {
      addHover(_i3);
    }
  }
};

var cancelSelectionDays = function cancelSelectionDays(e) {
  if (!currentSelf || e.key !== "Escape") return;
  currentSelf.selectedDates = [];
  currentSelf.HTMLElement.removeEventListener("mousemove", hoverDaysEvent);
  document.removeEventListener("keydown", cancelSelectionDays);
  mainMethod(currentSelf);
};

var setDisabledDates = function setDisabledDates() {
  var _a;

  if (!currentSelf || !((_a = currentSelf.selectedDates) == null ? void 0 : _a[0]) || !currentSelf.rangeDisabled || currentSelf.rangeDisabled.length < 2) return;
  var selectedDate =
  /* @__PURE__ */
  new Date("".concat(currentSelf.selectedDates[0], "T00:00:00"));
  var startDate = null;
  var endDate = null;

  for (var index = 0; index < currentSelf.rangeDisabled.length; index++) {
    var disabledDate =
    /* @__PURE__ */
    new Date("".concat(currentSelf.rangeDisabled[index], "T00:00:00"));

    if (selectedDate >= disabledDate) {
      startDate = disabledDate;
    } else {
      endDate = disabledDate;
      break;
    }
  }

  if (startDate) {
    startDate = new Date(startDate.setDate(startDate.getDate() + 1));
    currentSelf.rangeMin = generateDate(startDate);
  }

  if (endDate) {
    endDate = new Date(endDate.setDate(endDate.getDate() - 1));
    currentSelf.rangeMax = generateDate(endDate);
  }
};

var resetDisabledDates = function resetDisabledDates() {
  if (!currentSelf) return;
  currentSelf.rangeMin = currentSelf.settings.range.min;
  currentSelf.rangeMax = currentSelf.settings.range.max;

  if (currentSelf.settings.range.disablePast &&
  /* @__PURE__ */
  new Date("".concat(currentSelf.settings.range.min, "T00:00:00")) < currentSelf.date.today) {
    currentSelf.rangeMin = generateDate(currentSelf.date.today);
  }
};

var handlerMultipleRanged = function handlerMultipleRanged(self) {
  if (!self || !self.selectedDates) return;
  currentSelf = self;

  if (self.selectedDates[0] && self.selectedDates.length <= 1) {
    self.HTMLElement.addEventListener("mousemove", hoverDaysEvent);
    document.addEventListener("keydown", cancelSelectionDays);
    if (self.settings.range.disableGaps) setDisabledDates();
  } else {
    self.HTMLElement.removeEventListener("mousemove", hoverDaysEvent);
    document.removeEventListener("keydown", cancelSelectionDays);
    if (self.settings.range.disableGaps) resetDisabledDates();
  }
};

var getColumnID = function getColumnID(self, columnClass, personalClass, id, dataAttr) {
  var columnEls = self.HTMLElement.querySelectorAll(".".concat(self.CSSClasses.column));

  var indexColumn = _toConsumableArray(columnEls).findIndex(function (column) {
    return column.classList.contains(columnClass);
  });

  var currentValue = Number(columnEls[indexColumn].querySelector(".".concat(personalClass)).getAttribute(dataAttr));
  if (self.currentType === "month" && indexColumn >= 0) return id - indexColumn;
  if (self.currentType === "year" && self.selectedYear !== currentValue) return id - 1;
  return id;
};

var clickCalendar = function clickCalendar(self) {
  self.HTMLElement.addEventListener("click", function (e) {
    var element = e.target;
    var arrowEl = element.closest(".".concat(self.CSSClasses.arrow));
    var arrowPrevEl = element.closest(".".concat(self.CSSClasses.arrowPrev));
    var arrowNextEl = element.closest(".".concat(self.CSSClasses.arrowNext));
    var dayBtnEl = element.closest(".".concat(self.CSSClasses.dayBtn));
    var dayBtnPrevEl = element.closest(".".concat(self.CSSClasses.dayBtnPrev));
    var dayBtnNextEl = element.closest(".".concat(self.CSSClasses.dayBtnNext));
    var weekNumberEl = element.closest(".".concat(self.CSSClasses.weekNumber));
    var yearHeaderEl = element.closest(".".concat(self.CSSClasses.year));
    var yearItemEl = element.closest(".".concat(self.CSSClasses.yearsYear));
    var monthHeaderEl = element.closest(".".concat(self.CSSClasses.month));
    var monthItemEl = element.closest(".".concat(self.CSSClasses.monthsMonth));
    var gridEl = element.closest(".".concat(self.CSSClasses.grid));
    var columnEl = element.closest(".".concat(self.CSSClasses.column));

    var clickArrowMonth = function clickArrowMonth() {
      if (arrowEl && self.currentType !== "year" && self.currentType !== "month") {
        changeMonth(self, element.dataset.calendarArrow);
      }

      if (arrowEl) {
        if (self.actions.clickArrow) self.actions.clickArrow(e, Number(self.selectedYear), Number(self.selectedMonth));
      }
    };

    var clickDaySingle = function clickDaySingle() {
      if (!self.selectedDates || !dayBtnEl || !dayBtnEl.dataset.calendarDay) return;

      if (dayBtnEl.classList.contains(self.CSSClasses.dayBtnSelected)) {
        self.selectedDates.splice(self.selectedDates.indexOf(dayBtnEl.dataset.calendarDay), 1);
      } else {
        self.selectedDates = [];
        self.selectedDates.push(dayBtnEl.dataset.calendarDay);
      }
    };

    var clickDayMultiple = function clickDayMultiple() {
      if (!self.selectedDates || !dayBtnEl || !dayBtnEl.dataset.calendarDay) return;

      if (dayBtnEl.classList.contains(self.CSSClasses.dayBtnSelected)) {
        self.selectedDates.splice(self.selectedDates.indexOf(dayBtnEl.dataset.calendarDay), 1);
      } else {
        self.selectedDates.push(dayBtnEl.dataset.calendarDay);
      }
    };

    var clickDayMultipleRanged = function clickDayMultipleRanged() {
      if (!self.selectedDates || !dayBtnEl || !dayBtnEl.dataset.calendarDay) return;

      if (self.selectedDates.length <= 1 && self.selectedDates[0] && self.selectedDates[0].includes(dayBtnEl.dataset.calendarDay)) {
        self.selectedDates = [];
      } else {
        if (self.selectedDates.length > 1) self.selectedDates = [];
        self.selectedDates.push(dayBtnEl.dataset.calendarDay);
      }

      if (self.selectedDates[1]) {
        var startDate = new Date(
        /* @__PURE__ */
        new Date("".concat(self.selectedDates[0], "T00:00:00")).getFullYear(),
        /* @__PURE__ */
        new Date("".concat(self.selectedDates[0], "T00:00:00")).getMonth(),
        /* @__PURE__ */
        new Date("".concat(self.selectedDates[0], "T00:00:00")).getDate());
        var endDate = new Date(
        /* @__PURE__ */
        new Date("".concat(self.selectedDates[1], "T00:00:00")).getFullYear(),
        /* @__PURE__ */
        new Date("".concat(self.selectedDates[1], "T00:00:00")).getMonth(),
        /* @__PURE__ */
        new Date("".concat(self.selectedDates[1], "T00:00:00")).getDate());

        var addSelectedDate = function addSelectedDate(day) {
          if (!self.selectedDates) return;
          var date = generateDate(day);
          if (self.rangeDisabled && self.rangeDisabled.includes(date)) return;
          self.selectedDates.push(date);
        };

        self.selectedDates = [];

        if (endDate > startDate) {
          for (var i = startDate; i <= endDate; i.setDate(i.getDate() + 1)) {
            addSelectedDate(i);
          }
        } else {
          for (var _i4 = startDate; _i4 >= endDate; _i4.setDate(_i4.getDate() - 1)) {
            addSelectedDate(_i4);
          }
        }
      }

      handlerMultipleRanged(self);
    };

    var clickDay = function clickDay() {
      if (self.settings.selection.day && ["single", "multiple", "multiple-ranged"].includes(self.settings.selection.day) && dayBtnEl) {
        switch (self.settings.selection.day) {
          case "single":
            clickDaySingle();
            break;

          case "multiple":
            clickDayMultiple();
            break;

          case "multiple-ranged":
            clickDayMultipleRanged();
            break;
        }

        if (self.actions.clickDay) self.actions.clickDay(e, self.selectedDates);

        if (self.input && self.HTMLInputElement && self.HTMLElement && self.actions.changeToInput) {
          var calendar = {
            hide: function hide() {
              self.HTMLElement.classList.add(self.CSSClasses.calendarHidden);
            },
            show: function show() {
              self.HTMLElement.classList.remove(self.CSSClasses.calendarHidden);
            },
            HTMLInputElement: self.HTMLInputElement,
            HTMLElement: self.HTMLElement
          };
          self.actions.changeToInput(e, calendar, self.selectedDates, self.selectedTime, self.selectedHours, self.selectedMinutes, self.selectedKeeping);
        }

        if (dayBtnPrevEl) {
          changeMonth(self, "prev");
        } else if (dayBtnNextEl) {
          changeMonth(self, "next");
        } else {
          createDays(self);
        }
      }
    };

    var clickWeekNumber = function clickWeekNumber() {
      var _a;

      if (!self.settings.visibility.weekNumbers || !weekNumberEl || !self.actions.clickWeekNumber) return;
      var daysToWeeks = (_a = self.HTMLElement) == null ? void 0 : _a.querySelectorAll("[data-calendar-week-number]");
      if (!daysToWeeks) return;
      var weekNumberValue = Number(weekNumberEl.innerText);
      var yearWeek = Number(weekNumberEl.dataset.calendarYearWeek);

      var daysOfThisWeek = _toConsumableArray(daysToWeeks).filter(function (day) {
        return Number(day.dataset.calendarWeekNumber) === weekNumberValue;
      });

      self.actions.clickWeekNumber(e, weekNumberValue, daysOfThisWeek, yearWeek);
    };

    var clickYear = function clickYear() {
      if (!self.settings.selection.year) return;

      if (arrowEl && self.currentType === "year") {
        if (self.viewYear === void 0) return;

        if (arrowNextEl) {
          self.viewYear += 15;
        } else if (arrowPrevEl) {
          self.viewYear -= 15;
        }

        createYears(self, e.target);
      } else if (self.currentType !== "year" && yearHeaderEl) {
        createYears(self, e.target);
      } else if (self.currentType === "year" && yearHeaderEl) {
        self.currentType = self.type;
        mainMethod(self);
      } else if (yearItemEl) {
        if (self.selectedMonth === void 0 || !self.dateMin || !self.dateMax) return;
        self.selectedYear = self.type === "multiple" ? getColumnID(self, self.CSSClasses.columnYear, self.CSSClasses.year, Number(yearItemEl.dataset.calendarYear), "data-calendar-selected-year") : Number(yearItemEl.dataset.calendarYear);
        self.currentType = self.type;

        if (self.selectedMonth < self.dateMin.getMonth() && self.selectedYear <= self.dateMin.getFullYear() || self.selectedYear < self.dateMin.getFullYear()) {
          self.selectedMonth = self.dateMin.getMonth();
          self.selectedYear = self.dateMin.getFullYear();
        }

        if (self.selectedMonth > self.dateMax.getMonth() && self.selectedYear >= self.dateMax.getFullYear() || self.selectedYear > self.dateMax.getFullYear()) {
          self.selectedMonth = self.dateMax.getMonth();
          self.selectedYear = self.dateMax.getFullYear();
        }

        if (self.actions.clickYear) self.actions.clickYear(e, self.selectedYear);
        mainMethod(self);
      } else if (self.type === "multiple" && self.currentType === "year" && gridEl && !columnEl) {
        self.currentType = self.type;
        mainMethod(self);
      }
    };

    var clickMonth = function clickMonth() {
      if (!self.settings.selection.month) return;

      if (self.currentType !== "month" && monthHeaderEl) {
        createMonths(self, e.target);
      } else if (self.currentType === "month" && monthHeaderEl) {
        self.currentType = self.type;
        mainMethod(self);
      } else if (monthItemEl) {
        if (self.selectedMonth === void 0 || !self.dateMin || !self.dateMax) return;
        self.selectedMonth = self.type === "multiple" ? getColumnID(self, self.CSSClasses.columnMonth, self.CSSClasses.month, Number(monthItemEl.dataset.calendarMonth), "data-calendar-selected-month") : Number(monthItemEl.dataset.calendarMonth);

        if (self.type === "multiple") {
          var column = monthItemEl.closest(".".concat(self.CSSClasses.columnMonth));
          var year = column.querySelector(".".concat(self.CSSClasses.year));
          self.selectedYear = Number(year.dataset.calendarSelectedYear);

          if (self.selectedMonth < self.dateMin.getMonth() && self.selectedYear <= self.dateMin.getFullYear()) {
            self.selectedMonth = self.dateMin.getMonth();
          }

          if (self.selectedMonth > self.dateMax.getMonth() && self.selectedYear >= self.dateMax.getFullYear()) {
            self.selectedMonth = self.dateMax.getMonth();
          }
        }

        self.currentType = self.type;
        if (self.actions.clickMonth) self.actions.clickMonth(e, self.selectedMonth);
        mainMethod(self);
      } else if (self.type === "multiple" && self.currentType === "month" && gridEl && !columnEl) {
        self.currentType = self.type;
        mainMethod(self);
      }
    };

    clickArrowMonth();
    clickDay();
    clickWeekNumber();
    clickYear();
    clickMonth();
  });
};

var createCalendarToInput = function createCalendarToInput(self) {
  if (!self.input || !self.HTMLElement || !self.HTMLElement.parentNode) return;
  self.HTMLInputElement = self.HTMLElement;
  var calendar = document.createElement("div");
  calendar.className = "".concat(self.CSSClasses.calendar, " ").concat(self.CSSClasses.calendarToInput, " ").concat(self.CSSClasses.calendarHidden);
  self.HTMLElement = calendar;
  document.body.append(self.HTMLElement);
};

var initCalendar = function initCalendar(self) {
  if (!self.HTMLElement) return;
  createCalendarToInput(self);
  resetCalendar(self);
  handlerInput(self);
  clickCalendar(self);
};

var DOMDefault = function DOMDefault(styles) {
  return "\n\t<div class=\"".concat(styles.header, "\">\n\t\t<#ArrowPrev />\n\t\t<div class=\"").concat(styles.headerContent, "\">\n\t\t\t<#Month />\n\t\t\t<#Year />\n\t\t</div>\n\t\t<#ArrowNext />\n\t</div>\n\t<div class=\"").concat(styles.wrapper, "\">\n\t\t<#WeekNumbers />\n\t\t<div class=\"").concat(styles.content, "\">\n\t\t\t<#Week />\n\t\t\t<#Days />\n\t\t</div>\n\t</div>\n\t<#ControlTime />\n");
};

var DOMMultiple = function DOMMultiple(styles) {
  return "\n\t<div class=\"".concat(styles.controls, "\">\n\t\t<#ArrowPrev />\n\t\t<#ArrowNext />\n\t</div>\n\t<div class=\"").concat(styles.grid, "\">\n\t\t<#Multiple>\n\t\t\t<div class=\"").concat(styles.column, "\">\n\t\t\t\t<div class=\"").concat(styles.header, "\">\n\t\t\t\t\t<div class=\"").concat(styles.headerContent, "\">\n\t\t\t\t\t\t<#Month />\n\t\t\t\t\t\t<#Year />\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"").concat(styles.wrapper, "\">\n\t\t\t\t\t<#WeekNumbers />\n\t\t\t\t\t<div class=\"").concat(styles.content, "\">\n\t\t\t\t\t\t<#Week />\n\t\t\t\t\t\t<#Days />\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t<#/Multiple>\n\t</div>\n\t<#ControlTime />\n");
};

var DOMMonths = function DOMMonths(styles) {
  return "\n\t<div class=\"".concat(styles.header, "\">\n\t\t<div class=\"").concat(styles.headerContent, "\">\n\t\t\t<#Month />\n\t\t\t<#Year />\n\t\t</div>\n\t</div>\n\t<div class=\"").concat(styles.wrapper, "\">\n\t\t<div class=\"").concat(styles.content, "\">\n\t\t\t<#Months />\n\t\t</div>\n\t</div>\n");
};

var DOMYears = function DOMYears(styles) {
  return "\n\t<div class=\"".concat(styles.header, "\">\n\t\t<#ArrowPrev />\n\t\t<div class=\"").concat(styles.headerContent, "\">\n\t\t\t<#Month />\n\t\t\t<#Year />\n\t\t</div>\n\t\t<#ArrowNext />\n\t</div>\n\t<div class=\"").concat(styles.wrapper, "\">\n\t\t<div class=\"").concat(styles.content, "\">\n\t\t\t<#Years />\n\t\t</div>\n\t</div>\n");
};

var classes = {
  calendar: "vanilla-calendar",
  calendarDefault: "vanilla-calendar_default",
  calendarMultiple: "vanilla-calendar_multiple",
  calendarMonth: "vanilla-calendar_month",
  calendarYear: "vanilla-calendar_year",
  calendarHidden: "vanilla-calendar_hidden",
  calendarToInput: "vanilla-calendar_to-input",
  controls: "vanilla-calendar-controls",
  grid: "vanilla-calendar-grid",
  gridDisabled: "vanilla-calendar-grid_disabled",
  column: "vanilla-calendar-column",
  columnMonth: "vanilla-calendar-column_month",
  columnYear: "vanilla-calendar-column_year",
  header: "vanilla-calendar-header",
  headerContent: "vanilla-calendar-header__content",
  month: "vanilla-calendar-month",
  monthDisabled: "vanilla-calendar-month_disabled",
  year: "vanilla-calendar-year",
  yearDisabled: "vanilla-calendar-year_disabled",
  arrow: "vanilla-calendar-arrow",
  arrowPrev: "vanilla-calendar-arrow_prev",
  arrowNext: "vanilla-calendar-arrow_next",
  wrapper: "vanilla-calendar-wrapper",
  content: "vanilla-calendar-content",
  week: "vanilla-calendar-week",
  weekDay: "vanilla-calendar-week__day",
  weekDayWeekend: "vanilla-calendar-week__day_weekend",
  days: "vanilla-calendar-days",
  daysSelecting: "vanilla-calendar-days_selecting",
  months: "vanilla-calendar-months",
  monthsSelecting: "vanilla-calendar-months_selecting",
  monthsMonth: "vanilla-calendar-months__month",
  monthsMonthSelected: "vanilla-calendar-months__month_selected",
  monthsMonthDisabled: "vanilla-calendar-months__month_disabled",
  years: "vanilla-calendar-years",
  yearsSelecting: "vanilla-calendar-years_selecting",
  yearsYear: "vanilla-calendar-years__year",
  yearsYearSelected: "vanilla-calendar-years__year_selected",
  yearsYearDisabled: "vanilla-calendar-years__year_disabled",
  time: "vanilla-calendar-time",
  timeContent: "vanilla-calendar-time__content",
  timeHours: "vanilla-calendar-time__hours",
  timeMinutes: "vanilla-calendar-time__minutes",
  timeKeeping: "vanilla-calendar-time__keeping",
  timeRanges: "vanilla-calendar-time__ranges",
  timeRange: "vanilla-calendar-time__range",
  day: "vanilla-calendar-day",
  daySelected: "vanilla-calendar-day_selected",
  daySelectedFirst: "vanilla-calendar-day_selected-first",
  daySelectedLast: "vanilla-calendar-day_selected-last",
  daySelectedIntermediate: "vanilla-calendar-day_selected-intermediate",
  dayPopup: "vanilla-calendar-day__popup",
  dayBtn: "vanilla-calendar-day__btn",
  dayBtnPrev: "vanilla-calendar-day__btn_prev",
  dayBtnNext: "vanilla-calendar-day__btn_next",
  dayBtnToday: "vanilla-calendar-day__btn_today",
  dayBtnSelected: "vanilla-calendar-day__btn_selected",
  dayBtnHover: "vanilla-calendar-day__btn_hover",
  dayBtnDisabled: "vanilla-calendar-day__btn_disabled",
  dayBtnIntermediate: "vanilla-calendar-day__btn_intermediate",
  dayBtnWeekend: "vanilla-calendar-day__btn_weekend",
  dayBtnHoliday: "vanilla-calendar-day__btn_holiday",
  weekNumbers: "vanilla-calendar-week-numbers",
  weekNumbersTitle: "vanilla-calendar-week-numbers__title",
  weekNumbersContent: "vanilla-calendar-week-numbers__content",
  weekNumber: "vanilla-calendar-week-number",
  isFocus: "vanilla-calendar-is-focus"
};

var VanillaCalendar = function VanillaCalendar(selector, option) {
  var _this = this;

  _classCallCheck(this, VanillaCalendar);

  __publicField(this, "HTMLElement");

  __publicField(this, "input");

  __publicField(this, "type");

  __publicField(this, "months");

  __publicField(this, "jumpMonths");

  __publicField(this, "date");

  __publicField(this, "settings");

  __publicField(this, "locale");

  __publicField(this, "actions");

  __publicField(this, "popups");

  __publicField(this, "CSSClasses");

  __publicField(this, "DOMTemplates");

  __publicField(this, "currentType");

  __publicField(this, "reset", function () {
    return resetCalendar(_this);
  });

  __publicField(this, "update", function () {
    return updateCalendar(_this);
  });

  __publicField(this, "init", function () {
    return initCalendar(_this);
  });

  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V, _W, _X, _Y, _Z, __, _$, _aa, _ba, _ca, _da, _ea, _fa, _ga, _ha, _ia, _ja, _ka, _la, _ma, _na, _oa, _pa, _qa, _ra, _sa, _ta, _ua, _va, _wa, _xa, _ya, _za, _Aa, _Ba, _Ca, _Da, _Ea, _Fa, _Ga, _Ha, _Ia, _Ja, _Ka, _La, _Ma, _Na, _Oa, _Pa, _Qa, _Ra, _Sa, _Ta, _Ua, _Va, _Wa, _Xa, _Ya, _Za, __a, _$a, _ab, _bb, _cb, _db, _eb, _fb, _gb, _hb, _ib, _jb, _kb, _lb, _mb, _nb, _ob, _pb, _qb, _rb, _sb;

  this.HTMLElement = typeof selector === "string" ? document.querySelector(selector) : selector;
  if (!this.HTMLElement) return;
  this.input = (_a = option == null ? void 0 : option.input) != null ? _a : false;
  this.type = (_b = option == null ? void 0 : option.type) != null ? _b : "default";
  this.months = (_c = option == null ? void 0 : option.months) != null ? _c : 2;
  this.jumpMonths = (_d = option == null ? void 0 : option.jumpMonths) != null ? _d : 1;
  this.date = {
    min: (_f = (_e = option == null ? void 0 : option.date) == null ? void 0 : _e.min) != null ? _f : "1970-01-01",
    max: (_h = (_g = option == null ? void 0 : option.date) == null ? void 0 : _g.max) != null ? _h : "2470-12-31",
    today: (_j = (_i = option == null ? void 0 : option.date) == null ? void 0 : _i.today) != null ? _j :
    /* @__PURE__ */
    new Date()
  };
  this.settings = {
    lang: (_l = (_k = option == null ? void 0 : option.settings) == null ? void 0 : _k.lang) != null ? _l : "en",
    iso8601: (_n = (_m = option == null ? void 0 : option.settings) == null ? void 0 : _m.iso8601) != null ? _n : true,
    range: {
      min: (_q = (_p = (_o = option == null ? void 0 : option.settings) == null ? void 0 : _o.range) == null ? void 0 : _p.min) != null ? _q : this.date.min,
      max: (_t = (_s = (_r = option == null ? void 0 : option.settings) == null ? void 0 : _r.range) == null ? void 0 : _s.max) != null ? _t : this.date.max,
      disablePast: (_w = (_v = (_u = option == null ? void 0 : option.settings) == null ? void 0 : _u.range) == null ? void 0 : _v.disablePast) != null ? _w : false,
      disableGaps: (_z = (_y = (_x = option == null ? void 0 : option.settings) == null ? void 0 : _x.range) == null ? void 0 : _y.disableGaps) != null ? _z : false,
      disableAllDays: (_C = (_B = (_A = option == null ? void 0 : option.settings) == null ? void 0 : _A.range) == null ? void 0 : _B.disableAllDays) != null ? _C : false,
      disableWeekday: (_F = (_E = (_D = option == null ? void 0 : option.settings) == null ? void 0 : _D.range) == null ? void 0 : _E.disableWeekday) != null ? _F : null,
      disabled: (_I = (_H = (_G = option == null ? void 0 : option.settings) == null ? void 0 : _G.range) == null ? void 0 : _H.disabled) != null ? _I : null,
      enabled: (_L = (_K = (_J = option == null ? void 0 : option.settings) == null ? void 0 : _J.range) == null ? void 0 : _K.enabled) != null ? _L : null
    },
    selection: {
      day: (_O = (_N = (_M = option == null ? void 0 : option.settings) == null ? void 0 : _M.selection) == null ? void 0 : _N.day) != null ? _O : "single",
      month: (_R = (_Q = (_P = option == null ? void 0 : option.settings) == null ? void 0 : _P.selection) == null ? void 0 : _Q.month) != null ? _R : true,
      year: (_U = (_T = (_S = option == null ? void 0 : option.settings) == null ? void 0 : _S.selection) == null ? void 0 : _T.year) != null ? _U : true,
      time: (_X = (_W = (_V = option == null ? void 0 : option.settings) == null ? void 0 : _V.selection) == null ? void 0 : _W.time) != null ? _X : false,
      controlTime: (__ = (_Z = (_Y = option == null ? void 0 : option.settings) == null ? void 0 : _Y.selection) == null ? void 0 : _Z.controlTime) != null ? __ : "all",
      stepHours: (_ba = (_aa = (_$ = option == null ? void 0 : option.settings) == null ? void 0 : _$.selection) == null ? void 0 : _aa.stepHours) != null ? _ba : 1,
      stepMinutes: (_ea = (_da = (_ca = option == null ? void 0 : option.settings) == null ? void 0 : _ca.selection) == null ? void 0 : _da.stepMinutes) != null ? _ea : 1
    },
    selected: {
      dates: (_ha = (_ga = (_fa = option == null ? void 0 : option.settings) == null ? void 0 : _fa.selected) == null ? void 0 : _ga.dates) != null ? _ha : null,
      month: (_ka = (_ja = (_ia = option == null ? void 0 : option.settings) == null ? void 0 : _ia.selected) == null ? void 0 : _ja.month) != null ? _ka : null,
      year: (_na = (_ma = (_la = option == null ? void 0 : option.settings) == null ? void 0 : _la.selected) == null ? void 0 : _ma.year) != null ? _na : null,
      holidays: (_qa = (_pa = (_oa = option == null ? void 0 : option.settings) == null ? void 0 : _oa.selected) == null ? void 0 : _pa.holidays) != null ? _qa : null,
      time: (_ta = (_sa = (_ra = option == null ? void 0 : option.settings) == null ? void 0 : _ra.selected) == null ? void 0 : _sa.time) != null ? _ta : null
    },
    visibility: {
      theme: (_wa = (_va = (_ua = option == null ? void 0 : option.settings) == null ? void 0 : _ua.visibility) == null ? void 0 : _va.theme) != null ? _wa : "system",
      themeDetect: (_za = (_ya = (_xa = option == null ? void 0 : option.settings) == null ? void 0 : _xa.visibility) == null ? void 0 : _ya.themeDetect) != null ? _za : "html[data-theme]",
      monthShort: (_Ca = (_Ba = (_Aa = option == null ? void 0 : option.settings) == null ? void 0 : _Aa.visibility) == null ? void 0 : _Ba.monthShort) != null ? _Ca : true,
      weekNumbers: (_Fa = (_Ea = (_Da = option == null ? void 0 : option.settings) == null ? void 0 : _Da.visibility) == null ? void 0 : _Ea.weekNumbers) != null ? _Fa : false,
      weekend: (_Ia = (_Ha = (_Ga = option == null ? void 0 : option.settings) == null ? void 0 : _Ga.visibility) == null ? void 0 : _Ha.weekend) != null ? _Ia : true,
      today: (_La = (_Ka = (_Ja = option == null ? void 0 : option.settings) == null ? void 0 : _Ja.visibility) == null ? void 0 : _Ka.today) != null ? _La : true,
      disabled: (_Oa = (_Na = (_Ma = option == null ? void 0 : option.settings) == null ? void 0 : _Ma.visibility) == null ? void 0 : _Na.disabled) != null ? _Oa : false,
      daysOutside: (_Ra = (_Qa = (_Pa = option == null ? void 0 : option.settings) == null ? void 0 : _Pa.visibility) == null ? void 0 : _Qa.daysOutside) != null ? _Ra : true
    }
  };
  this.locale = {
    months: (_Ta = (_Sa = option == null ? void 0 : option.locale) == null ? void 0 : _Sa.months) != null ? _Ta : [],
    weekday: (_Va = (_Ua = option == null ? void 0 : option.locale) == null ? void 0 : _Ua.weekday) != null ? _Va : []
  };
  this.actions = {
    clickDay: (_Xa = (_Wa = option == null ? void 0 : option.actions) == null ? void 0 : _Wa.clickDay) != null ? _Xa : null,
    clickWeekNumber: (_Za = (_Ya = option == null ? void 0 : option.actions) == null ? void 0 : _Ya.clickWeekNumber) != null ? _Za : null,
    clickMonth: (_$a = (__a = option == null ? void 0 : option.actions) == null ? void 0 : __a.clickMonth) != null ? _$a : null,
    clickYear: (_bb = (_ab = option == null ? void 0 : option.actions) == null ? void 0 : _ab.clickYear) != null ? _bb : null,
    clickArrow: (_db = (_cb = option == null ? void 0 : option.actions) == null ? void 0 : _cb.clickArrow) != null ? _db : null,
    changeTime: (_fb = (_eb = option == null ? void 0 : option.actions) == null ? void 0 : _eb.changeTime) != null ? _fb : null,
    changeToInput: (_hb = (_gb = option == null ? void 0 : option.actions) == null ? void 0 : _gb.changeToInput) != null ? _hb : null,
    getDays: (_jb = (_ib = option == null ? void 0 : option.actions) == null ? void 0 : _ib.getDays) != null ? _jb : null
  };
  this.popups = (_kb = option == null ? void 0 : option.popups) != null ? _kb : null;

  this.CSSClasses = function () {
    var classesObj = __spreadValues({}, classes);

    Object.keys(classes).forEach(function (className) {
      var _a2;

      if ((_a2 = option == null ? void 0 : option.CSSClasses) == null ? void 0 : _a2[className]) {
        classesObj[className] = option.CSSClasses[className];
      } else {
        classesObj[className] = classes[className];
      }
    });
    return classesObj;
  }();

  this.DOMTemplates = {
    default: (_mb = (_lb = option == null ? void 0 : option.DOMTemplates) == null ? void 0 : _lb.default) != null ? _mb : DOMDefault(this.CSSClasses),
    multiple: (_ob = (_nb = option == null ? void 0 : option.DOMTemplates) == null ? void 0 : _nb.multiple) != null ? _ob : DOMMultiple(this.CSSClasses),
    month: (_qb = (_pb = option == null ? void 0 : option.DOMTemplates) == null ? void 0 : _pb.month) != null ? _qb : DOMMonths(this.CSSClasses),
    year: (_sb = (_rb = option == null ? void 0 : option.DOMTemplates) == null ? void 0 : _rb.year) != null ? _sb : DOMYears(this.CSSClasses)
  };
  this.currentType = this.type;
};

export { VanillaCalendar as default };